import CallDealerModal from '../src/components/CallDealerModal/CallDealerModal';

export default CallDealerModal;
